import React, { useState, useEffect } from 'react'
import { AlertProvider } from './global-whatsapp/context/AlertContext';
import { useAuth } from './global-whatsapp/context/AuthContext'
import { Route, Routes } from 'react-router'


import AuthRoutes from './global-whatsapp/routes/AuthRoutes'

import LogoutPage from './global-whatsapp/app/auth/pages/LogoutPage';
import RechargePage from './global-whatsapp/app/admin/business/pages/RechargePage';
import SuspendPage from './global-whatsapp/app/admin/business/pages/SuspendPage';

import Error404Page from './global-whatsapp/app/errorPages/Error404Page';
import Error401Page from './global-whatsapp/app/errorPages/Error401Page';
import ChangePasswordPage from './global-whatsapp/app/auth/pages/ChangePasswordPage';
import AdminRoutes from './global-whatsapp/routes/AdminRoutes'
import ManagerRoutes from './global-whatsapp/routes/ManagerRoutes';
import WhatsAppAdminRoutes from './global-whatsapp/routes/WhatsAppAdminRoutes';
import WhatsAppUserRoutes from './global-whatsapp/routes/WhatsAppUserRoutes';
import GrievanceAdminRoutes from './global-whatsapp/routes/GrievanceAdminRoutes';
import GrievanceSupervisorRoutes from './global-whatsapp/routes/GrievanceSupervisorRoutes';
import GrievanceInspectorRoutes from './global-whatsapp/routes/GrievanceInspectorRoutes';



function App() {
    const {isLoggedIn,authUser} = useAuth();
    //console.log("authUSerrole", authUser)
    sessionStorage.removeItem("businessInfo");

    // Disable Right Click Start
    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])
    // Disable Right Click End

    useEffect(()=>{
        sessionStorage.removeItem("staffList");
    },[])
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                    { authUser.role == 1 &&
                        <AdminRoutes/>
                    }
                    { authUser.role == 2 &&
                        <ManagerRoutes/>
                    }

                    { authUser.role == 3 &&
                        <WhatsAppAdminRoutes/>
                    }

                    { authUser.role == 4 &&
                        <GrievanceAdminRoutes/>
                    }

                    { authUser.role == 5 &&
                        <GrievanceSupervisorRoutes />
                    }

                    { authUser.role == 6 &&
                        <GrievanceInspectorRoutes/>
                    }
                    
                    { authUser.role == 7 &&
                        <WhatsAppUserRoutes/>
                    }
                    
                    <Routes>
                        {/*Logout */}
                        <Route path="/admin/recharge-page" element={<RechargePage />}></Route>
                        <Route path="/admin/suspend-page" element={<SuspendPage />}></Route>
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                        <Route path="/auth/change-password" element={<ChangePasswordPage />}></Route>
                        <Route path="/404" element={<Error404Page/>}></Route>
                        <Route path="/401" element={<Error401Page/>}></Route>
                    </Routes> 
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App